<template>
  <div class="transfer-labor" v-if="Object.keys(item).length > 0">
    <div class="transfer-labor__text" v-html="item.text"></div>
    <div class="flex flex-wrap">
      <el-button
        type="primary"
        size="small"
        class="transfer-labor__btn"
        v-for="(item1, index) in item.transfer"
        :key="index"
        @click="handleGroupClick(item1.id)"
      >
        {{ item1.name }}
      </el-button>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
const props = defineProps({
  item: { type: Object, default: () => {} }
})
const emit = defineEmits(['switch'])
const handleGroupClick = (id) => {
  emit('switch', { type: 11, groupId: id })
}
</script>
<style lang="less" scoped>
.transfer-labor {
  &__text {
    padding-bottom: 10px;
  }
}
</style>
